import React, {Component} from "react";

export class DateFormatSelect extends Component {
    static dateCurrencyFormats = ["YYYY-MM-DD", "MM/DD/YYYY", "DD/MM/YYYY"]

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    getDateFormats() {
        return DateFormatSelect.dateCurrencyFormats;
    }

    handleChange(event) {
        if(this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    }

    renderNullOptionIfNecessary() {
        if(this.props.selected === null) {
            return <option key='empty-option' value=''>-----</option>
        }
    }

    render() {
        // `selected` es `null` mientras no se eligió nada (y en el alta del Sheet, hasta importar el
        // archivo). React exige string en un control controlado: con `null` tira el warning
        // "`value` prop on `input` should not be null" y ensucia cada corrida de tests.
        const selected = this.props.selected || '';
        if(this.props.readOnly===true) {
            return <input value={selected} readOnly={true} className={"form-control"}/>
        }

        const options = this.getDateFormats();
        return (<select className={"form-control"}
                        value={selected} {...this.props}
                        onChange={this.handleChange}
                        required={this.props.required}
            >
                {this.renderNullOptionIfNecessary()}
                {options.map((option) => (
                    <option value={option}
                            key={option}
                    >{option}</option>
                ))}
            </select>
        )
    }
}
